var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 89,
    fill: "#fff",
    stroke: "#CBD0DC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M73.34 116.94h-7.05c-10.79-.77-15.63-9.07-15.63-16.44 0-7.38 4.84-15.71 15.45-16.45a2.73 2.73 0 0 1 2.93 2.57 2.75 2.75 0 0 1-2.57 2.94c-7.12.51-10.3 5.87-10.3 10.97 0 5.1 3.18 10.46 10.3 10.98h6.87c1.5 0 2.75 1.24 2.75 2.75 0 1.5-1.25 2.68-2.75 2.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M107.14 116.94h-.18c-1.5 0-2.9-1.25-2.9-2.75a2.67 2.67 0 0 1 2.71-2.76c4.52 0 8.55-1.57 11.71-4.4 5.73-5 6.1-12.19 4.55-17.25-1.54-5.03-5.83-10.8-13.32-11.7a2.76 2.76 0 0 1-2.39-2.28c-1.46-8.81-6.2-14.9-13.4-17.1a21.52 21.52 0 0 0-21.46 5.6C67.2 69.79 66 77.46 69.04 85.9a2.75 2.75 0 1 1-5.17 1.87c-3.7-10.35-2.02-20.26 4.62-27.23a27.22 27.22 0 0 1 27.05-7.09c8.59 2.65 14.65 9.73 16.85 19.57 7.48 1.69 13.5 7.37 15.89 15.23 2.6 8.55.26 17.36-6.17 22.94a22.38 22.38 0 0 1-14.97 5.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M90 127.73a21.09 21.09 0 0 1-18.06-10.28c-.4-.62-.8-1.36-1.14-2.16a20.09 20.09 0 0 1-1.9-8.66c0-11.64 9.47-21.1 21.1-21.1 11.64 0 21.1 9.46 21.1 21.1 0 3.12-.66 6.05-1.98 8.77-.3.7-.7 1.43-1.14 2.13A20.97 20.97 0 0 1 90 127.73Zm0-36.7c-8.59 0-15.6 7-15.6 15.6 0 2.27.48 4.4 1.4 6.35a15.51 15.51 0 0 0 14.17 9.25 15.5 15.5 0 0 0 14.12-9.14c1-2.02 1.47-4.15 1.47-6.43A15.59 15.59 0 0 0 90 91.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M87.9 113.01c-.69 0-1.39-.26-1.94-.8l-3.63-3.64a2.77 2.77 0 0 1 0-3.89 2.77 2.77 0 0 1 3.89 0l1.76 1.76 5.87-5.43a2.77 2.77 0 0 1 3.9.15 2.77 2.77 0 0 1-.15 3.89l-7.82 7.23a2.9 2.9 0 0 1-1.87.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c88a52d1ddf42cda024e21f09b328eb8.svg";
export { ForwardRef as ReactComponent };